module.exports = __webpack_public_path__ + "static/SNB FINANCE HOLDINGS LIMITED CUSTOMER AGREEMENT v7.0 FD-d539fa35064e606f0ab1cae61c067560.pdf";